import { Component, inject, OnInit } from '@angular/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NZ_MODAL_DATA } from 'ng-zorro-antd/modal';

@Component({
  template: `
    <div class="offer-modal__error">
      <div class="offer-modal__content">
        Processing of your request was not successful. If the problem persist after you tried again, contact your
        administrator.
      </div>
      <div class="offer-modal__actions">
        <button
          id="offer-modal__download__actions__try-again"
          class="offer-modal__actions--primary offer-modal__actions--danger"
          nz-button
          (click)="onRetry()"
        >
          <i
            nz-icon
            nzType="reload"
          ></i
          >Try again
        </button>
      </div>
    </div>
  `,
  imports: [NzButtonModule, NzIconModule],
  standalone: true
})
export class ProcessErrorModalComponent implements OnInit {
  private modalData = inject(NZ_MODAL_DATA);

  public onRetry: () => void = () => {};

  ngOnInit() {
    const { onRetry } = this.modalData;
    this.onRetry = onRetry;
  }
}
